import React, { memo } from 'react';
import { Routes, Route } from 'react-router';
import { EXTERNAL_ROUTES } from '../routes';

import LazyRouteContent from 'components/LazyRouteContent';

const ExternalRouter = memo(() => {
    return (
        <Routes>
            {EXTERNAL_ROUTES.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={<LazyRouteContent>{route.element}</LazyRouteContent>}
                />
            ))}
        </Routes>
    );
});

ExternalRouter.displayName = 'ExternalRouter';

export default ExternalRouter;
